import PropTypes from 'prop-types';
import formatNumber from '../../utils/format-number';
import { monthlyPrice, yearlyPrice } from '../../utils/price-for-period';
import { BILLING_PERIODS } from '../../utils/constants';

export default function PeriodPrice({ cost, billingPeriod, period }) {
    if (period === BILLING_PERIODS.MONTH) {
        return (
            <>
                <span>$</span>
                {formatNumber(monthlyPrice(cost, billingPeriod))}
                <small>/mo</small>
            </>
        );
    }

    return (
        <>
            <span>$</span>
            {formatNumber(yearlyPrice(cost, billingPeriod))}
            <small>/year</small>
        </>
    );
}

PeriodPrice.propTypes = {
    cost: PropTypes.number.isRequired,
    billingPeriod: PropTypes.string.isRequired,
    period: PropTypes.string.isRequired,
};
